import * as React from 'react';
import { type User } from '@/auth';
import { FeatureContext } from '../../FeatureContext';
import DmsSetting from './dms-setting/DmsSettings';
import LinkServiceSetting from './link-service-setting/LinkServiceSetting';
import AiReportSetting from './ai-report-setting/AiReportSetting';
import DeviceSettings from './device-setting/DeviceSettings';

type Props = {
  user: User;
};

/**
 * 設定画面コンポーネント
 * 
 * ユーザーの権限に応じて以下の設定項目を表示する：
 * - DMS設定: テナント機能設定権限を持つユーザー（管理者）のみ表示
 * - 連携サービス設定: 全ユーザーに表示
 * - AIレポート設定: テナント機能設定権限とinsightReporter機能の両方が有効な場合のみ表示
 * 
 * @param props - コンポーネントのプロパティ
 * @param props.user - 現在のユーザー情報
 * @returns 設定画面のJSX要素
 */
export default function Settings(props: Props) {

  const features = React.useContext(FeatureContext);

  //管理者にのみDmsSettingコンポーネントを表示する
  //連携サービス設定は全ユーザに表示する
  return (
    <div style={{ height: '100%', overflowY: 'scroll' }}>
      {features.isTenantFeatureSetting() && <DmsSetting user={props.user} />}
      {<DeviceSettings user={props.user} />}
      {<LinkServiceSetting user={props.user} />}
      {features.isTenantFeatureSetting() && features.insightReporter?.() && <AiReportSetting user={props.user} />}
    </div>
  );
}